import React from 'react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Anchor, Box, Inline } from '@atlaskit/primitives/compiled';

import { getRelativeTime } from '@confluence/macro-utils/entry-points/getRelativeTime.ts';

import type { ContributorData } from './hooks/useProcessedContributorsResult.ts';
import { i18n } from './contributorsMacroI18n.ts';

export interface ContributorItemProps {
	contributor: ContributorData;
	showCount: boolean;
	showTime: boolean;
}

const styles = cssMap({
	anchor: {
		textDecoration: 'none',
	},
});

export const ContributorItem = ({ contributor, showCount, showTime }: ContributorItemProps) => {
	const profileUrl = `/wiki/display/~${contributor.id}`;
	const intl = useIntl();

	return (
		<Inline as="span" space="space.050">
			<Anchor
				testId={`contributor-link-${contributor.id}`}
				href={profileUrl}
				target="_blank"
				xcss={styles.anchor}
			>
				{contributor.fullName}
			</Anchor>
			{showCount && (
				<Box as="span" testId={`contributor-count-${contributor.id}`}>
					{contributor.totalCount}
				</Box>
			)}
			{showTime && (
				<Box as="span" testId={`contributor-time-${contributor.id}`}>
					{intl.formatMessage(i18n.lastActiveTime, {
						time: getRelativeTime(contributor.lastActiveTime, intl),
					})}
				</Box>
			)}
		</Inline>
	);
};
